import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { EmptyState as BaseEmptyState } from '@lyearn/molecules';
import { Stack } from '@lyearn/ui';

function EmptyState({ searchText }: { searchText: string }) {
  const { t } = useTranslation();

  return (
    <Stack className="h-full w-full p-24" direction="col" justifyContent="center">
      {searchText.length ? (
        <BaseEmptyState
          className="pb-80"
          description={t('Common:EmptyState.NoResultsSearch', { searchText })}
          title={t('Discover:Category.Admin.NoCategoryFound')}
        />
      ) : (
        <BaseEmptyState
          className="pb-80"
          description={t('Discover:Category.Admin.NoCategoryAvailableDescription')}
          title={t('Discover:Category.Admin.NoCategoryAvailable')}
        />
      )}
    </Stack>
  );
}

export default EmptyState;
